import { render, staticRenderFns } from "./ProductsFilterCategory.vue?vue&type=template&id=6d28b4e2&"
import script from "./ProductsFilterCategory.vue?vue&type=script&lang=js&"
export * from "./ProductsFilterCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports